import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
export default function CheckList(props) {

    const navigate = useNavigate();
    const [linkText, setLinkText] = useState('click here');

    const navigatePageLink = () => {
        setLinkText('');
        navigate("/checkApplicationStatus"); 
    };

    return (
        <div>
            <div className="bg-image d-flex justify-content-center align-items-center bannerChecklist">
                {/* <h1 className="whtClr">Checklist</h1> */}
            </div>

            {/* Content Section */}
            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 text-center">
                            <h3>T-Mobile Sub-Dealer Checklist</h3>
                            <p className="pHeading">
                                Please review the checklist below. If you can answer 'Yes' to all items, enter your corporate email
                                address <br className="hiddenTab" />
                                in the field below and submit
                            </p>
                        </div>
                    </div>

                    <br className="hiddenTab" />
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="checklistUl">
                                <ul>
                                    <li>Are a U.S. based Company Address</li>
                                    <li>Have a physical business operating address (no post office or private mailbox)</li>
                                    <li>
                                        Business is in good standing with the Secretary of State in which the business is registered
                                    </li>
                                    <li>
                                        Include a COMPANY website and email (no public domains allowed such as gmail.com or Hotmail.com)
                                    </li>
                                    <li>Federal Tax ID required</li>
                                    <li>Good standing with Better Business Bureau (BBB)</li>
                                    <li>Corporate Liable sales only (no individual sales)</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <p className="hiddenTab">&nbsp;</p>

                    <div className="row">
                        <div className="col-sm-12 text-center">
                            <h3>Let’s get started!</h3>
                            <form onSubmit={props.handleSubmit}>
                                <div className="form-group checklistForm">
                                    <input
                                        type="text"
                                        name="email"
                                        className="form-control"
                                        placeholder="Enter your corporate email address"
                                        value={props.email}
                                        onChange={props.handleInputChange}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                props.handleSubmit(e);
                                            }
                                        }}
                                    />
                                    <button
                                        type="submit"
                                        className="btn btn-sm btn-primary primaryBtn"
                                        disabled={props.loading} 
                                    >
                                        SUBMIT
                                    </button>
                                    
                                    {props.error && (
                                        <p className="text-danger">
                                            {props.error}
                                            {props.showButton && (
                                                 <div className="statusbtnnew">
                                                Please{' '}
                                                 <a onClick={navigatePageLink} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                                                     {linkText}
                                                 </a>{' '}
                                                 to see the status of your application.
                                             </div>
                                            )}
                                        </p>
                                    )}
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}
